$(".mysubcoll").slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1200,
  slidesToShow: 10,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  prevArrow:
    '<div class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0065/0045/0351/files/left-chevron.png?v=1697700634"></div>',
  nextArrow:
    '<div class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0065/0045/0351/files/chevron.png?v=1697700669"></div>',
  responsive: [
    {
      breakpoint: 767,
      settings: "unslick",
    },
  ],
});
$(".main_slider").slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1200,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  adaptiveHeight: true,
});

$(".m-announcement-bar__content").slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 1200,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(document).ready(function () {
  // Go to Cart button -- Visible only on non-empty cart
  $("button.originalmyqbtn.add-to-cart").on("click", function () {
    setTimeout(function () {
      var myctotal = $(
        ".m-cart__summary.m-cart-drawer__summary .m-cart__subtotal span.m-cart__subtotal--price"
      ).text();
      $("span.price_atc").text(myctotal);
      jQuery.getJSON("/cart.js", function (cart, textStatus) {
        if (cart.item_count > 0) {
          $(".sticky-atc").addClass("active");
        } else {
          $(".sticky-atc").removeClass("active");
        }
      });
      var mycnt = $("span.itam_count span.sf-cart-count.font-medium").text();
    }, 1500);
  });

  $(document).on(
    "click",
    "button.scd__close.p-2.cursor-pointer.absolute",
    function () {
      setTimeout(function () {
        jQuery.getJSON("/cart.js", function (cart, textStatus) {
          if (cart.item_count > 0) {
            $(".sticky-atc").addClass("active");
          } else {
            $(".sticky-atc").removeClass("active");
          }
        });
        var myctotal = $(
          ".m-cart__summary.m-cart-drawer__summary .m-cart__subtotal span.m-cart__subtotal--price"
        ).text();
        $("span.price_atc").text(myctotal);
      }, 1500);
    }
  );

  $("body#m-theme").on("click", function () {
    setTimeout(function () {
      jQuery.getJSON("/cart.js", function (cart, textStatus) {
        if (cart.item_count > 0) {
          $(".sticky-atc").addClass("active");
        } else {
          $(".sticky-atc").removeClass("active");
        }
      });
      var myctotal = $(
        ".m-cart__summary.m-cart-drawer__summary .m-cart__subtotal span.m-cart__subtotal--price"
      ).text();
      $("span.price_atc").text(myctotal);
    }, 1500);
  });

  $(".dropdown.collection_dropdown p.load").on("click", function () {
    $(".collection_dropdown .dropdown-content").toggle();
  });

  $(".switch input").on("click", function () {
    $(this).parent().toggleClass("active");
    if (this.checked) {
      $(".myswitch .swiper-slide").show();
      $(".myswitch .m-product-item").show();
    } else {
      $(".myswitch .swiper-slide").each(function () {
        var thisvalss = $(this).attr("data_type");
        if (thisvalss == "isEggless") {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
      $(".myswitch .m-product-item").each(function () {
        var thisvalss = $(this).attr("data_type");
        if (thisvalss == "isEggless") {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  });

  $("select.delivery_city").on("change", function () {
    var myfill = $(this).val();
    $(".m-featured-collection .myprogrid").each(function () {
      var collval = $(this).attr("data_coltwo");
      if (collval == myfill) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
    $(".dropdown-content ul").each(function () {
      var collvalww = $(this).attr("data_coltag");
      if (collvalww == myfill) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  // disabled auto open cart drawer on clicking adding product to the cart
  $(document).on("click", ".m-add-to-cart", function () {
    $("m-cart-drawer#MinimogCartDrawer").hide();
    $("html.js.prevent-scroll").removeClass("prevent-scroll");
  });

  // Show cart drawer on clicking cart icon on header
  $("a.m-cart-icon-bubble").on("click", function () {
    $("m-cart-drawer#MinimogCartDrawer").show();
  });

  // var optionqty = $(document).find(".product-options__option.product-options__option--button.Bestseller span.font-semibold.selected-value").text();
  // $('.defaultval span').text(optionqty);
  // $(document).on('click', '.quantity .plus', function (e) {
  //     $(this).closest('.flavor_list').find('.floavor_name input[type="checkbox"]').prop('checked', true);
  //     var optionqty = $(document).find(".product-options__option.product-options__option--button.Bestseller span.font-semibold.selected-value").text();
  //     var totalqty = 0;
  //     // alert(optionqty)
  //     let $input = $(this).prev('input.qty');
  //     let val = parseInt($input.val());
  //     $input.val(val + 1).change();

  //     $('.flavorlist_data .qty').each(function () {
  //         var this_val = $(this).val();
  //         if (this_val != 0) {
  //             totalqty += parseFloat(this_val);
  //         }
  //     });
  //     if (optionqty == totalqty) {
  //         $('input.qtyplus.plus').each(function () {
  //             $(this).prop('disabled', true);
  //         });
  //         $('.flavorlist_data .qty').each(function () {
  //             var this_val_zero = $(this).val();
  //             if (this_val_zero == 0) {
  //                 $(this).closest('.flavor_list').css("pointer-events", "none");
  //             }
  //         });
  //     }
  //     if (totalqty == optionqty) {
  //         $('p.choose_option').hide();
  //     }
  // });

  // $(document).on("click", ".variant-picker__option label.product-option-item.sf-po__option-button", function () {
  //     $("p.choose_option").css("display", "none");
  //     $(".flavorlist_data input[name='flavor_name']").each(function () {
  //         $(this).prop('checked', false);
  //     });
  //     $('.flavorlist_data .qty').each(function () {
  //         $(this).val(0);
  //     });
  //     $('.flavor_qty.quantity').each(function () {
  //         $(this).css("pointer-events", "none");
  //     });
  //     $('.flavor_list').each(function () {
  //         $(this).css("pointer-events", "unset");
  //     });
  //     $('input.qtyplus.plus').each(function () {
  //         $(this).prop('disabled', false);
  //     });
  // });

  // $(document).on('click', '.quantity .minus', function (e) {
  //     $(this).closest('.flavor_list').find('.floavor_name input[type="checkbox"]').prop('checked', false);
  //     var optionqty = $(document).find(".product-options__option.product-options__option--button.Bestseller span.font-semibold.selected-value").text();
  //     var totalqty = 0;
  //     let $input = $(this).next('input.qty');
  //     var val = parseInt($input.val());
  //     if (val > 0) {
  //         $input.val(val - 1).change();
  //     }
  //     $('.flavorlist_data .qty').each(function () {
  //         var this_val = $(this).val();
  //         if (this_val != 0) {
  //             totalqty += parseFloat(this_val);
  //         }
  //     });
  //     if (optionqty == totalqty) {
  //         $('input.qtyplus.plus').each(function () {
  //             $(this).prop('disabled', true);
  //         });
  //         $('.flavorlist_data .qty').each(function () {
  //             var this_val_zero = $(this).val();
  //             if (this_val_zero == 0) {
  //                 $(this).closest('.flavor_list').css("pointer-events", "none");
  //             }
  //         });
  //     } else {
  //         $('input.qtyplus.plus').each(function () {
  //             $(this).prop('disabled', false);
  //         });
  //         $('.flavorlist_data .qty').each(function () {
  //             var this_val_zero = $(this).val();
  //             if (this_val_zero == 0) {
  //                 $(this).closest('.flavor_list').css("pointer-events", "unset");

  //             }
  //         });
  //     }
  //     if (totalqty == optionqty) {
  //         $('p.choose_option').hide();
  //     }
  // });

  // $(document).on("click", ".floavor_name input[type=checkbox]", function () {
  //     var qty_check = $(this).closest('.flavor_list').find('.qty').val();
  //     if (this.checked) {
  //         $(this).closest('.flavor_list').find('.qty').val(1);
  //         $(this).closest('.flavor_list').find('.flavor_qty.quantity').css("pointer-events", "unset");
  //     } else {
  //         $(this).closest('.flavor_list').find('.qty').val(0);
  //         $(this).closest('.flavor_list').find('.flavor_qty.quantity').css("pointer-events", "none");
  //     }
  //     var totalqty = 0;

  //     var optionqty = $(document).find(".product-options__option.product-options__option--button.Bestseller span.font-semibold.selected-value").text();

  //     $('.flavorlist_data .qty').each(function () {
  //         var this_val = $(this).val();

  //         if (this_val != 0) {
  //             totalqty += parseFloat(this_val);
  //         }
  //     });
  //     if (optionqty == totalqty) {
  //         $('input.qtyplus.plus').each(function () {
  //             $(this).prop('disabled', true);
  //         });
  //         $('.flavorlist_data .qty').each(function () {
  //             var this_val_zero = $(this).val();
  //             if (this_val_zero == 0) {
  //                 $(this).closest('.flavor_list').css("pointer-events", "none");
  //             }
  //         });
  //     } else {
  //         $('input.qtyplus.plus').each(function () {
  //             $(this).prop('disabled', false);
  //         });
  //         $('.flavorlist_data .qty').each(function () {
  //             var this_val_zero = $(this).val();
  //             if (this_val_zero == 0) {
  //                 $(this).closest('.flavor_list').css("pointer-events", "unset");
  //             }
  //         });
  //     }

  // });

  // $(document).on("click", "#cus_addtocart", function () {
  //     $('.product-options.onlybestsell .product-options__option.product-options__option--button.Bestseller input:checked').each(function () {
  //         var myqtys = $(this).attr('myqty');
  //         event.preventDefault();
  //         var variant_id = $(document).find("#formId").val();
  //         var varQty = $(document).find("quantity-input input.quantity-input__element").val();
  //         var checkedlength = $(".flavorlist_data input[name='flavor_name']:checked").length;
  //         var checkedlength = 0;
  //         $(".flavorlist_data input[name='flavor_name']:checked").each(function (index) {
  //             var nameqty = $(this).closest('.flavor_list').find('.qty').val();
  //             checkedlength += parseInt(nameqty);
  //         });
  //         //var mycity = $('select#selectCity').val();
  //         var mydate = $('input.neo-input').val();
  //         // alert(checkedlength);
  //         var categories = '';
  //         if (myqtys == checkedlength) {
  //             event.stopPropagation();
  //             $("p.choose_option").css("display", "none");
  //             $(".flavorlist_data input[name='flavor_name']:checked").each(function (index) {
  //                 var nameqty = $(this).closest('.flavor_list').find('.qty').val();
  //                 if (nameqty != 0) {
  //                     var name = $(this).val();
  //                     var combine = name + ' * ' + nameqty + ',';
  //                     categories += combine;
  //                 }
  //             });
  //             var categories = categories.replace(/,\s*$/, "");
  //             var arrdata = {
  //                 "id": variant_id,
  //                 "quantity": varQty,
  //                 "properties": {
  //                     "Flavors": categories,
  //                     "Preferred Date & Delivery Slot": mydate
  //                 }
  //             }
  //             jQuery.ajax({
  //                 type: "POST",
  //                 url: "/cart/add.js",
  //                 data: arrdata,
  //                 dataType: "json",
  //                 success: function () {
  //                     window.location.href = "/cart";
  //                 }
  //             });
  //         } else {
  //             // $("p.choose_option span").text(option_value);
  //             // $("p.choose_option").css("display", "block");
  //         }

  //     });
  // });

  $(document).on("click", "button.add-to-cart", function () {
    $("#zoomImage").addClass("zoomed");
    setTimeout(function () {
      $("#zoomImage").removeClass("zoomed");
    }, 1000);
  });

  $(document).on("change", "select#selectCity", function () {
    var isdvala = $(this).val();
    if (isdvala != "bangalore") {
      $("span#cus_addtocart2").hide();
      $(".originalmyqbtn").show();
      $(".originalmyqbtn").prop("disabled", false);
    }
  });

  $(".m-menu-mobile__toggle-button").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".m-megamenu-mobile").slideUp(200);
    } else {
      $(this).addClass("active");
      $(this).siblings(".m-megamenu-mobile").slideDown(200);
    }
  });

  $(".myForm").on("input", function () {
    let allFilled = true;
    $(".myForm").each(function () {
      if ($(this).val() === "") {
        allFilled = false;
      }
    });
    if (allFilled) {
      $("#mysubmitbtn").on("click", function () {
        setTimeout(function () {
          window.location.href = "https://amintiri.in/pages/thank-you";
        }, 3000);
      });
    }
  });

  var mydisnsjc = $("#formId").val();
  $(document).on(
    "click",
    "form.f-upsell__product-inner button.foxkit-button",
    function () {
      var $form = $(this).closest("foxkit-product-card");
      var variantValue = $form
        .find("select.sf-product-variant-option-dropdown option:selected")
        .text();
      var productID = $form.attr("data-product-id");
      var productTitle = $form.find("h3.h4 a").text();
      var productPrice = $form.find(".foxkit-product-card__price").text();
      var numericPrice = productPrice.replace(/[^\d]/g, "");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "dam_add_to_cart",
        ecommerce: {
          currency: "{{ shop.currency }}",
          value: numericPrice,
          items: [
            {
              item_id: productID,
              item_name: productTitle,
              item_variant: variantValue,
              price: numericPrice,
            },
          ],
        },
      });
    }
  );
});
